import CommonRouter from './CommonRouter'
import { ecommerceRoutes } from '../routes/EcommerceRoutes'
const CurrentNavigator = CommonRouter('Shopping', ecommerceRoutes.Cart)
export default CurrentNavigator
